import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"
import img from "../../../assets/images/Wwings.png"
//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./Sidebar"

// Super Admin

import { Link } from "react-router-dom"

const Sidebar = props => {

  const isDevelopment = process.env.NODE_ENV === "development"

  // Define the class name based on the environment
  const className = isDevelopment ? "development" : ""
  return (
    <React.Fragment>
      <div className={`vertical-menu ${className}`}>
        <div
          className="navbar-brand-box"
          style={{ left: "-32px", top: "10px" }}
        >
          <Link to="" className="logo logo-dark">
            <span className="logo-sm">
              <img src={img} alt="" height="30" />
            </span>
            <span className="logo-lg">
              <img src={img} alt="" height="85" />
            </span>
          </Link>

          <Link to="" className="logo logo-light pb-3">
            <span className="logo-sm">
              <img src={img} alt="" height="30" />
            </span>
            <span className="logo-lg">
              <img src={img} alt="" height="85" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
